export const formInitialValues = {
  relevantBusinessUnit: "",
  resource_topics: [],
  resource_industries: [],
};
